const servicesList = [
  'Asphalt Driveway',
  'Asphalt Grading',
  'Asphalt Paving',
  'New Construction Installation',
  'Resurfacing',
  'Asphalt Repair',
  'Asphalt Milling',
  'Crack Filling',
  'Patching',
  'Commercial Paving',
  'Concrete Paving',
  'Concrete Flatwork',
  'Municipal Paving',
  'Parking Lot Paving',
  'Parking Lot Repair',
  'Pavement Maintenance',
  'Asphalt Chip Sealing',
  'Asphalt Crack Sealing',
  'Asphalt Sealcoating',
  'Asphalt Sealing',
  'Parking Lot Striping',
];

export default function ServicesSection() {
  const half = Math.ceil(servicesList.length / 2);
  const col1 = servicesList.slice(0, half);
  const col2 = servicesList.slice(half);

  return (
    <section className="py-16 md:py-20 bg-gray-900 text-white" id="services">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col lg:flex-row gap-10">
          {/* Left: Map + Photo */}
          <div className="w-full lg:w-1/2 flex flex-col gap-4">
            <div className="rounded-lg overflow-hidden h-[300px] md:h-[350px]">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1547626.6082490773!2d-75.55954785!3d39.8338515!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c0fb959e00409f%3A0x2cd27b07e3f4f459!2sNew%20Jersey!5e0!3m2!1sen!2sus!4v1749674000000!5m2!1sen!2sus"
                width="100%"
                height="100%"
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="New Jersey Map"
                className="w-full h-full border-0"
              ></iframe>
            </div>
            <div className="rounded-lg overflow-hidden h-[220px] md:h-[230px] w-full">
              <img
                src="https://public.readdy.ai/ai/img_res/9b82d8431ddac085fd63870402c3edc9.jpg"
                alt="Commercial asphalt paving crew at work in New Jersey"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          {/* Right: Services list */}
          <div className="w-full lg:w-1/2">
            <div className="border-b border-gray-600 pb-4 mb-8">
              <h2
                className="text-2xl md:text-3xl font-extrabold uppercase leading-tight"
                style={{ fontFamily: "'Oswald', sans-serif" }}
              >
                Services Offered in
                <br />
                <strong className="text-yellow-400">New Jersey</strong>
              </h2>
            </div>

            <div className="flex gap-6">
              <ul className="space-y-3 flex-1">
                {col1.map((service) => (
                  <li key={service} className="flex items-center gap-2 text-sm md:text-base">
                    <span className="w-2 h-2 bg-yellow-400 rounded-full flex-shrink-0"></span>
                    <a href="#contact" className="hover:text-yellow-400 transition-colors cursor-pointer">
                      {service}
                    </a>
                  </li>
                ))}
              </ul>
              <ul className="space-y-3 flex-1">
                {col2.map((service) => (
                  <li key={service} className="flex items-center gap-2 text-sm md:text-base">
                    <span className="w-2 h-2 bg-yellow-400 rounded-full flex-shrink-0"></span>
                    <a href="#contact" className="hover:text-yellow-400 transition-colors cursor-pointer">
                      {service}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
